import { render, staticRenderFns } from "./kpi-punish.vue?vue&type=template&id=8c4d5d4c"
import script from "./kpi-punish.vue?vue&type=script&lang=js"
export * from "./kpi-punish.vue?vue&type=script&lang=js"
import style0 from "./kpi-punish.vue?vue&type=style&index=0&id=8c4d5d4c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports